import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/view/home') // 首页
    },
    {
      path: '/intro',
      name: 'intro',
      component: () => import('@/view/intro') // 公司简介
    },
    // ===================================
    {
      path: '/robot',
      name: 'robot',
      component: () => import('@/view/robot') // AMR机器人
    },
    {
      path: '/battery',
      name: 'battery',
      component: () => import('@/view/battery') // 换电产品
    },
    {
      path: '/energy',
      name: 'energy',
      component: () => import('@/view/energy') // 储能产品
    },
    // ===============================================
    {
      path: '/motorcycle',
      name: 'motorcycle',
      component: () => import('@/view/motorcycle') // 合作车型
    },
    {
      path: '/microgrid',
      name: 'microgrid',
      component: () => import('@/view/microgrid') // 分布式微电网
    },
    {
      path: '/journalism',
      name: 'journalism',
      component: () => import('@/view/journalism') // 新闻中心
    },
    {
      path: '/business',
      name: 'business',
      component: () => import('@/view/business') // 商务合作
    },
    {
      path: '/engage',
      name: 'engage',
      component: () => import('@/view/engage') // 公司招聘
    },
    {
      path: '/sitePage',
      name: 'sitePage',
      component: () => import('@/view/sitePage') // 轮播跳转的详情
    },
    {
      path: '/needDetail',
      name: 'needDetail',
      component: () => import('@/view/needDetail') // 职位详情
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js